import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
import { LangContext } from '../App';
import { translations } from '../lib/translations';

const ABOUT_IMAGE =
  'https://images.pexels.com/photos/6077520/pexels-photo-6077520.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

const fadeUp = {
  initial: { opacity: 0, y: 35 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.3 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export default function About() {
  const lang = useContext(LangContext);
  const t = translations[lang].about;

  return (
    <section
      id="about"
      className="py-28 bg-white"
      data-testid="about-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 xl:gap-24 items-center">

          {/* Image */}
          <motion.div
            className="relative"
            {...fadeUp}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Escritório de advocacia"
                className="w-full h-full object-cover grayscale-[15%] hover:grayscale-0 transition-all duration-700"
                data-testid="about-image"
              />
            </div>
            {/* Decorative border offset */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#E5E0D8] -z-10" />
          </motion.div>

          {/* Text */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          >
            <p className="font-sans text-xs tracking-[0.3em] uppercase text-[#6B2D3E] mb-6">
              — {t.sectionLabel} —
            </p>

            <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] leading-tight tracking-tight mb-8">
              {t.title}
            </h2>

            <div className="w-10 h-px bg-[#6B2D3E] mb-8" />

            <p className="font-sans text-base text-[#4A4A4A] leading-relaxed mb-5">
              {t.bio1}
            </p>
            <p className="font-sans text-base text-[#4A4A4A] leading-relaxed mb-10">
              {t.bio2}
            </p>

            <div
              className="flex items-center gap-3 pt-6 border-t border-[#E5E0D8]"
              data-testid="about-bar-membership"
            >
              <Award size={16} className="text-[#6B2D3E] flex-shrink-0" />
              <span className="font-sans text-sm text-[#6B2D3E] tracking-wide">
                {t.bar}
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
